import { Component, Output, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { IAbstractView } from '@core/interfaces';
import { ILoginStrategyComponent, ILoginStrategyPresenter } from './interfaces';
import { LoginStrategyPresenter } from './login-strategy.presenter';
import { AuthModalComponentEnum } from '../../../enums';
import { ButtonComponent, InputComponent } from '@shared/components'; 
import { DialogTypeEnum } from '@shared/components/dialog/enums';

@Component({
	selector: 'app-login-strategy',
	templateUrl: './login-strategy.component.html',
	styleUrls: ['./login-strategy.component.scss'],
	standalone: true,
	imports: [CommonModule, ReactiveFormsModule, IonicModule, ButtonComponent, InputComponent],
})
export class LoginStrategyComponent extends IAbstractView<ILoginStrategyPresenter> implements ILoginStrategyComponent {
	DialogTypeEnum = DialogTypeEnum;
	loading$ = this.presenter.loading$;
	loadingStore$ = this.presenter.loadingStore$;
	translations = this.presenter.translations;
	formGroup = this.presenter.formGroup;
	AuthModalComponentEnum = this.presenter.AuthModalComponentEnum;

	@Input({ required: true }) callback = this.presenter.callback;
	@Input() visitingCheckout = this.presenter.visitingCheckout;
	@Output() guest = this.presenter.guest;

	constructor(presenter: LoginStrategyPresenter) {
		super(presenter);
	}

	onLogIn(): void {
		this.presenter.onLogIn();
	}

	isFieldInvalid(fieldName: string): boolean {
		return this.presenter.isFieldInvalid(fieldName);
	}

	getFieldErrorMessage(fieldName: string): string {
		return this.presenter.getFieldErrorMessage(fieldName);
	}

	navigateTo(route: AuthModalComponentEnum): void {
		this.presenter.navigateTo(route);
	}

	navigateGuest(): void {
		this.presenter.navigateGuest();
	}

	getButtonType(isDisabled: boolean | null): 'button-primary' {
		return (isDisabled ? 'button-primary disabled' : 'button-primary') as unknown as 'button-primary';
	}

	closeModal(): void {}
}
